import React, { useState } from "react";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Screen6.module.css";
import { BiSolidPlusCircle } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
// import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
const Screen6 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isModalOpen, setIsModalOpen] = useState(
    WeddingWeb?.accommodation ? false : true
  );
  const [description, setDescription] = useState(WeddingWeb?.accommodation);
  // const [id, setId] = useState();
  //   const [answer, setAnswer] = useState("");
  // const [detailsArr, setDetailsArr] = useState([]);
  // const [editItem, setEditItem] = useState();
  // console.log("detailsArrr", detailsArr);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onClickNext = () => {
    if (!description) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please Add atleast one detail",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 6,
          weddingWebId: WeddingWeb?.id,
          description,
        })
      ).then(() => navigate("/events"));
    }
  };
  // const saveDetails = () => {
  //   if (!description) {
  //     dispatch(
  //       showAlert({
  //         type: "Error",
  //         message: "All fields are mandatory",
  //       })
  //     );
  //   } else {
  //     let dummyArr = [...detailsArr];
  //     dummyArr.push({
  //       id: detailsArr?.length + 1,
  //       description: description,
  //       // answer: answer,
  //     });
  //     setDetailsArr(dummyArr);
  //     setIsModalOpen(false);
  //     setDescription("");
  //     //   setAnswer("");
  //     setId();
  //   }
  // };
  // const onClickEditBtn = (item) => {
  //   setIsEditModalOpen(true);
  //   setId(item?.id);
  //   setDescription(item?.description);
  //   // setAnswer(item?.answer)
  // };
  // const editDetails = () => {
  //   let data = {
  //     id: id,
  //     description: description,
  //     //   answer: answer,
  //   };
  //   let index = detailsArr.findIndex((item) => item?.id == id);
  //   setDetailsArr((prev) => {
  //     prev.splice(index, 1, data);
  //     return prev;
  //   });
  //   setIsEditModalOpen(false);
  //   setDescription("");
  //   //  setAnswer("");
  //   setId();
  // };

  // const renderItem = (item, index) => {
  //   return (
  //     <div className={styles.listItem} key={index}>
  //       <TextComponent text={item?.description} textClass={styles.desc} />
  //       {/* <TextComponent text={item?.answer} textClass={styles.desc} /> */}
  //       <TextComponent
  //         text={"Edit"}
  //         textClass={styles.editBtn}
  //         onClick={() => onClickEditBtn(item)}
  //       />
  //     </div>
  //   );
  // };
  return (
    <>
      <div className={styles.content}>
        <div className={styles.textCont}>
          <TextComponent text={"Accommodation"} />
        </div>
      </div>
      {/* {detailsArr && (
        <div className={styles.listDiv}>
          <List
            grid={{ lg: 2, xxl: 2, xl: 2, xs: 1, md: 2, sm: 1 }}
            dataSource={detailsArr}
            renderItem={renderItem}
            className={styles.list}
          />
        </div>
      )} */}

      {description && (
        <div className={styles.itemDiv}>
          <div className={styles.listItem}>
            <TextComponent text={description} textClass={styles.desc} />
            {/* <TextComponent text={item?.answer} textClass={styles.desc} /> */}
            <TextComponent
              text={"Edit"}
              textClass={styles.editBtn}
              onClick={() => setIsModalOpen(true)}
            />
          </div>
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          <BiSolidPlusCircle className={styles.addIcon} />
          <TextComponent text={"Add"} />
        </div>
        <div className={styles.nextBtn}>
          <SubmitButton title={"Back to Home"}
           onClick={onClickNext} 
           />
        </div>
      </div>

      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        pinkBg={true}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <TextareaField
            placeholder={"Write Here"}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
          {/* <TextareaField
              placeholder={"Answer"}
              onChange={(e) => setAnswer(e.target.value)}
              value={answer}
            /> */}
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      </Modal>
      {/* <Modal
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        closable={true}
        pinkBg={true}
        onClose={() => {
          setId();
          setDescription("");
        }}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <InputField
            placeholder={"description"}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
          <TextareaField
              placeholder={"Answer"}
              onChange={(e) => setAnswer(e.target.value)}
              value={answer}
            />
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={editDetails}
            />
          </div>
        </div>
      </Modal> */}
    </>
  );
};

export default Screen6;
